import { PaymentType } from '@/features/graphql/generated/graphql'
import AmountInput from '@/features/shiftCloseouts/components/AmountInput'
import { useActualAmountField } from '@/features/shiftCloseouts/form'
import { FC } from 'react'
import { StyleProp, ViewStyle } from 'react-native'

interface ManualAmountProps {
    accessibilityLabel: string
    currency: string
    paymentType: PaymentType
    style?: StyleProp<ViewStyle>
}

const ManualAmount: FC<ManualAmountProps> = ({
    accessibilityLabel,
    currency,
    paymentType,
    style,
}) => {
    const actualAmountField = useActualAmountField(paymentType)

    return (
        <AmountInput
            accessibilityLabel={accessibilityLabel}
            allowNegative
            currency={currency}
            error={actualAmountField.invalid}
            onBlur={actualAmountField.onBlur}
            onChange={actualAmountField.onChange}
            style={style}
            testID={`shift-closeout-actual-${paymentType}`}
            value={actualAmountField.value}
        />
    )
}

export default ManualAmount
